var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.715,
    height: 19.698,
    viewBox: "0 0 19.715 19.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13064",
    "data-name": "Grupo 13064",
    transform: "translate(-1128 -383.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_488",
    "data-name": "Trazado 488",
    d: "M10,11.739a4.426,4.426,0,0,0,6.675.478l2.656-2.656a4.426,4.426,0,1,0-6.26-6.26L11.549,4.816",
    transform: "translate(1126.087 382.797)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_489",
    "data-name": "Trazado 489",
    d: "M12.623,10.77a4.426,4.426,0,0,0-6.675-.478L3.292,12.948a4.426,4.426,0,1,0,6.26,6.26l1.513-1.514",
    transform: "translate(1127.005 381.996)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f7f56e9548493f6fcee4604dbff0a6b0.svg";
export { ForwardRef as ReactComponent };